<template>
  <div :class="['contact', {zIndex:zIndex}, {contactMedia:dev}]">
    <div class="container">
      <div class="bgPoster"></div>
      <img
        class="bg"
        :src="require('@/assets/img/last/contactBg.png')"
      >
      <div class="content">
        <h2 class="title">
          <img
            :src="require('@/assets/img/last/close.png')"
            class="close"
            @click="close"
          >
          大侠，请输入手机号码，以便后续发放奖励
        </h2>
        <div class="input">
          <input
            @focus="inputFocus"
            @blur="inputBlur"
            type="text"
            v-model="phone"
          >

          <p class="prompt">
            <transition name="prompt">
              <span v-if="msg">{{msg}}</span>
            </transition>
          </p>

        </div>
        <button
          @click="submit"
          class="btn"
        >确定</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  props: {
    contactHide: Function,
    zIndex: Boolean
  },
  data() {
    return {
      msg: "",
      phone: ""
    };
  },
  computed: {
    dev() {
      return this.$store.state.dev;
    }
  },
  methods: {
    submit() {
      let _this = this;
      $.ajax({
        url:
          "https://nshssl.hi.163.com/file_mg/public/share/yuyue/reservation/apply/nsh_zhuanzhi_yuyue",
        type: "POST",
        dataType: "json",
        data: { phone: _this.phone },
        success: function(res) {
          // -100  您已经成功参与活动了，不需要重复填写。
          // 1 填写成功
          // -2 活动还未开始
          // -3 活动已经结束
          // -4 请填写正确的手机号

          // 其他code  抱歉，网络繁忙，请稍后再试。
          switch (res.code) {
            case 1:
              _this.msg = "填写成功";
              setTimeout(() => {
                _this.close();
              }, 600);
              break;
            case -2:
              _this.msg = "活动还未开始";
              break;
            case -3:
              _this.msg = "活动已经结束";
              break;
            case -4:
              _this.msg = "请填写正确的手机号";
              break;
            case -100:
              _this.msg = "您已经成功参与活动了，不需要重复填写。";
              break;
            default:
              _this.msg = "抱歉，网络繁忙，请稍后再试。";
              break;
          }
        },
        error: function() {
          _this.msg = "抱歉，网络繁忙，请稍后再试。";
        }
      });
    },
    // input获得焦点
    inputFocus() {
      this.msg = "";
    },
    // inputBlur 失去焦点
    inputBlur() {
      document.body.scrollTop = 0;
    },
    // 关闭弹窗
    close() {
      this.contactHide();
      this.msg = "";
      this.phone = "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.prompt-enter-active,
.prompt-leave-active {
  transition: all 0.3s ease;
}
.prompt-leave-to,
.prompt-enter {
  top: -40%;
  opacity: 0;
}
.prompt-leave,
.prompt-enter-to {
  top: 0;
  opacity: 1;
}

.contact {
  @include LTput;
  @include wh(100%, 100%);
  background: rgba(0, 0, 0, 0.6);
  z-index: -1;
  opacity: 0;
  transition: all 0.5s ease;

  .container {
    @include wh(11.21rem);
    @include LTRBcenter;
    transform: translate(-50%, -70%);
    @media all and (max-width: 990px) {
      @include wh(13rem);
    }
    .bgPoster {
      @include imgPoster(28.8%);
    }
    .bg {
      @include wh(100%);
      @include LTput;
      display: block;
    }
    .close {
      @include TBcenter;
      @include wh(0.4rem);
      transform: translate(-130%, -50%);
      @media all and (max-width: 990px) {
        @include wh(0.5rem);
      }
    }
  }
}
.zIndex {
  z-index: 999;
  opacity: 1;
}
.content {
  @include LTput;
  @include wh(100%, 100%);
}

.title {
  font-size: 0.3rem;
  color: white;
  position: relative;
  @include fontFamily;
  @include wh(100%);
  margin-top: 0.6rem;
  margin-bottom: 0.15rem;
  text-align: center;
  @media all and (max-width: 990px) {
    font-size: 0.4rem;
  }
}
.input {
  display: block;
  input {
    display: block;
    margin: 0 auto;
    @include wh(3.95rem, 0.55rem);
    border: 0;
    outline: 0;
    border-radius: 10px;
    border: 1px solid #1c1825;
    font-size: 0.25rem;
    padding: 0 7px;
    box-sizing: border-box;
    background: white;
    @media all and (max-width: 990px) {
      @include wh(4rem, 0.6rem);
    }
  }
  .prompt {
    @include wh(5rem, 0.4rem);
    line-height: 0.36rem;
    @include fontFamily;
    font-size: 0.25rem;
    padding: 0 7px;
    box-sizing: border-box;
    color: #fe7d7d;
    position: relative;
    left: calc((100% - 3.95rem) / 2);
    @media all and (max-width: 990px) {
      font-size: 0.28rem;
    }
    span {
      position: absolute;
      display: block;
    }
  }
}
.btn {
  display: block;
  margin: 0 auto;
  @include fontFamily;
  font-size: 0.3rem;
  @include wh(0.9rem, 0.45rem);
  border: 1px solid #1c1825;
  border-radius: 12px;
  outline: 0;
  background: white;
  @media all and (max-width: 990px) {
    @include wh(1.2rem, 0.6rem);
    font-size: 0.4rem;
  }
}
.contactMedia {
  .container {
    @include wh(11.21rem);
    @include LTRBcenter;
    transform: translate(-50%, -70%);

    .close {
      @include TBcenter;
      @include wh(0.4rem);
      transform: translate(-130%, -50%);
    }
  }

  .title {
    font-size: 0.3rem;
    color: white;
    position: relative;
    @include fontFamily;
    @include wh(100%);
    margin-top: 0.6rem;
    margin-bottom: 0.15rem;
    text-align: center;
  }
  .input {
    display: block;
    input {
      display: block;
      margin: 0 auto;
      @include wh(3.95rem, 0.55rem);
      border: 0;
      outline: 0;
      border-radius: 10px;
      border: 1px solid #1c1825;
      font-size: 0.25rem;
      padding: 0 7px;
      box-sizing: border-box;
      background: white;
    }
    .prompt {
      @include wh(5rem, 0.4rem);
      line-height: 0.36rem;
      @include fontFamily;
      font-size: 0.25rem;
      padding: 0 7px;
      box-sizing: border-box;
      color: #fe7d7d;
      position: relative;
      left: calc((100% - 3.95rem) / 2);
      span {
        position: absolute;
        display: block;
      }
    }
  }
  .btn {
    display: block;
    margin: 0 auto;
    @include fontFamily;
    font-size: 0.3rem;
    @include wh(0.9rem, 0.45rem);
    border: 1px solid #1c1825;
    border-radius: 12px;
    outline: 0;
    background: white;
  }
}
</style>


